function getLabel(array, element) {
  if(array.filter((value) => { return value.data == element }).length > 0) {
    return array.filter((value) => { return value.data == element })[0].label;
  }
  return "";
}

function anoBaseDimob() {
  var today = new Date();
  var yyyy = today.getFullYear();

  return yyyy - 1;
}

function hoje() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();

  if(dd < 10) { dd = '0' + dd }
  if(mm < 10) { mm = '0' + mm }

  return dd + '/' + mm + '/' + yyyy;
}

function agora() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();

  var hh = today.getHours();
  var MM = today.getMinutes();

  if(dd < 10) { dd = '0' + dd }
  if(mm < 10) { mm = '0' + mm }
  if(hh < 10) { hh = '0' + hh }
  if(MM < 10) { MM = '0' + MM }

  return dd + '/' + mm + '/' + yyyy + " " + hh + ":" + MM;
}

function adicionarDiasData(days) {
  var result = new Date();
  result.setDate(result.getDate() + days);
  return result;
}

function adicionarDias(data, dias) {
  if(!data){
    return undefined
  }
  data = stringParaData(data)
  data.setDate(data.getDate() + dias);
  return data;
}

function adicionarMeses(data, meses) {
  if(!data){
    return undefined
  }

  if(isNaN(meses)) {
    return undefined;
  }
  
  var d = data.getDate()
  data.setMonth(data.getMonth() + +meses)
  if(data.getDate() != d){
    data.setDate(0)
  }
  return data
}

function stringParaData(dateStr) {
  const [day, month, year] = dateStr.split("/");
  return new Date(year, month - 1, day);
}

function dataParaString(date) {
  if(!date){
    return
  }
  var dd = date.getDate();
  var mm = date.getMonth() + 1; //January is 0!
  var yyyy = date.getFullYear();

  if(dd < 10) { dd = '0' + dd }
  if(mm < 10) { mm = '0' + mm }
  
  return [dd,mm,yyyy].join("/")

}

function primeiroDiaMes() {
  var today = new Date();
  var dd = '01';
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();

  if(mm < 10) { mm = '0' + mm }

  return dd + '/' + mm + '/' + yyyy;
}

function primeiroDiaMesData(data) {
  var dataFormatada = new Date(formatarData(data));
  var dd = '01';
  var mm = dataFormatada.getMonth() + 1; //January is 0!
  var yyyy = dataFormatada.getFullYear();

  if(mm < 10) { mm = '0' + mm }

  return dd + '/' + mm + '/' + yyyy;
}

function ultimoDiaMes() {
  var today = new Date();
  var ultimoDia = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();

  if(mm < 10) { mm = '0' + mm }

  return ultimoDia.getDate() + '/' + mm + '/' + yyyy;
}

function ultimoDiaMesData(data) {
  var dataFormatada = new Date(formatarData(data));
  var ultimoDia = new Date(dataFormatada.getFullYear(), dataFormatada.getMonth() + 1, 0);
  var mm = dataFormatada.getMonth() + 1; //January is 0!
  var yyyy = dataFormatada.getFullYear();

  if(mm < 10) { mm = '0' + mm }

  return ultimoDia.getDate() + '/' + mm + '/' + yyyy;
}

function diaDaData(data) {
  let dataFormatada = new Date(formatarData(data));
  return dataFormatada.getUTCDate();
}

function compararDatas(data1, data2) {
	var objDate1 = new Date(formatarData(data1));
  var objDate2 = new Date(formatarData(data2));
  
  if(objDate1 > objDate2) {
    return 1
  } else if(objDate1 < objDate2) {
    return -1
  }
	return 0;
}

function formatarEnderecoImovel(imovel) {
  if(imovel == undefined || imovel.id == 0) { return ""; }

  let texto = "(" + imovel.idNaImobiliaria + ") " +
    (imovel.tipoImovel !== undefined ? imovel.tipoImovel.nome + " - " : "")
    + imovel.endereco;

  let complementoEndereco = imovel.complemento;
  if(complementoEndereco !== undefined && complementoEndereco !== "") {texto += " - " + complementoEndereco}

  let numeroEndereco = imovel.numeroEndereco;
  if(numeroEndereco != undefined) { texto += ", " + numeroEndereco; }

  let bairro = imovel.bairro.nome;
  if(bairro != undefined) { texto += " (" + bairro + ")"; }

  return texto;
}

function formatarSelectCliente(cliente) {
  if(cliente === undefined || cliente.id === 0) {
    return "";
  }
  
  let texto = "";
  
  if(cliente.idNaImobiliaria) {
    texto += `(${cliente.idNaImobiliaria}) `;
  }

  texto += cliente.nome;

  if(cliente.cpfCnpj) {
    texto += " - " + cliente.cpfCnpj;
  }

  return texto;
}

function formatarLinha1EnderecoImovel(imovel) {
  if(!imovel || imovel.id == 0) { return "" }

  let texto =  imovel.endereco;
  if(imovel.numeroEndereco) { texto += ", " + imovel.numeroEndereco; }

  return texto;
}

function formatarLinha2EnderecoImovel(imovel, isTabelaImoveis = false) {
  if(!imovel || imovel.id == 0) { return "" }
  
  let texto = ""; 

  if(imovel.condominio.nome && isTabelaImoveis == false) {
    texto += `${imovel.condominio.nome} - `
  }
  texto += imovel.bairro.nome + " - " + imovel.cidade.nome;

  return texto;
}

function formatarValor(value) {
    if(value == undefined || value == null) {
        return ""
    }

    let val = (value/1).toFixed(2).replace('.', ',');
    return "R$ " + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

function formatarPercentual(value) {
  let val = (value/1).toFixed(2).replace('.', ',');
  return  val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " %";
}

function validarDataHora(dataHora) {
  if(dataHora == null || dataHora == undefined) {
    return false;
  }

  var data = dataHora.split(" ")[0];
  var hora = dataHora.split(" ")[1];
  
  if(!data || !hora){
    return false
  }

  return validarData(data) && validarHora(hora);
}

function validarData(data) {
  if(!data) { return false; }

  var dia = data.split("/")[0];
  var mes = data.split("/")[1];
  var ano = data.split("/")[2];

  var diasMes = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  if(ano < 1000 || ano > 3000 || mes == 0 || mes > 12) { return false; }

  if(ano % 400 == 0 || (ano % 100 != 0 && ano % 4 == 0)) {
    diasMes[1] = 29;
  }

  return dia > 0 && dia <= diasMes[mes - 1];
}

function validarHora(hora) {
  var horas = hora.split(":")[0];
  var minutos = hora.split(":")[1];

  if(horas < 0 || horas > 23) { return false; }
  
  return minutos >= 0 && minutos < 60;
}

function validarIntervaloDeHora(horaInicio, horaFim) {
  var hhInicio = parseInt(horaInicio.split(':')[0]);
  var mmInicio = parseInt(horaInicio.split(':')[1]);

  var hhFim = parseInt(horaFim.split(':')[0]);
  var mmFim = parseInt(horaFim.split(':')[1]);

  if(hhInicio > hhFim) { return false; }

  if(hhInicio == hhFim) {
    return mmFim > mmInicio;
  }

  return true;
}

function validarCpf(entrada) {
  if(!entrada) return false;

  let cpf = entrada.replace(/\./g, '').replace(/-/g, '');

  if(cpf === '00000000000') return false;
  if(cpf.length < 11) return false;

  let soma;
  let resto;
  
  soma = 0;
  for(let i=1; i<=9; i++) soma = soma + parseInt(cpf.substring(i-1, i)) * (11-i);
  resto = (soma*10) % 11;

  if((resto == 10) || (resto == 11)) resto = 0;
  if(resto != parseInt(cpf.substring(9, 10))) return false;

  soma = 0;
  for(let i=1; i<=10; i++) soma = soma + parseInt(cpf.substring(i-1, i)) * (12-i);
  resto = (soma*10) % 11;

  if((resto == 10) || (resto == 11)) resto = 0;
  if(resto != parseInt(cpf.substring(10, 11))) return false;

  return true;
}

function formatarData(dataStr) {
  // Formata data de "dd/mm/aaaa" para "aaaa-mm-dd"
  return dataStr.split('/').reverse().join('-');
}

function formatar2Digitos(valor) {
  return valor < 10 ? '0' + valor : valor.toString();
}

function removerAcentos(texto) {
  return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export default {
  getLabel,
  formatarEnderecoImovel,
  formatarLinha1EnderecoImovel,
  formatarLinha2EnderecoImovel,
  formatarSelectCliente,
  anoBaseDimob,
  hoje,
  agora,
  adicionarDiasData,
  adicionarDias,
  adicionarMeses,
  stringParaData,
  dataParaString,
  primeiroDiaMes,
  primeiroDiaMesData,
  ultimoDiaMes,
  ultimoDiaMesData,
  diaDaData,
  compararDatas,
  formatarValor,
  formatarPercentual,
  validarDataHora,
  validarData,
  validarHora,
  validarIntervaloDeHora,
  validarCpf,
  formatarData,
  formatar2Digitos,
  removerAcentos,
}